import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Payment } from '@components/templates/shoppingCart';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import useCartSummary from '@hooks/useCartSummary';
import { useData } from '@hooks/useData';
import { useGetCart } from '@services/useGetCart';

export function PaymentPage() {
    const { t, i18n } = useTranslation();
    const { request: requestCart, loading } = useGetCart();
    const { cart } = useData();
    const { formattedCart } = useCartSummary(cart?.data);

    const translations = {
        title: t('payment-component.metatags.title'),
        description: t('payment-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.orderPayment,
        index: false,
    });

    const onlyDigitalProducts = cart?.data?.cartType?.isDigitalOnly

    // call requestCart to update all cart data, including shipping calculations
    useEffect(() => {
        !loading && cart?.data?.shipping === null && requestCart({ with_shipping: !onlyDigitalProducts });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.data?.shipping, i18n.language]);

    const formattedTotal = formattedCart();

    return <Payment total={formattedTotal} />;
}
